module.exports = __webpack_public_path__ + "static/GDPR-Georeal-268ea103e6a1b94e83ea20e05949d579.pdf";